module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-100italic.e4bf47bd171a9b2a72dd84c58bf90edf.woff2";